export enum OfferRequestTimelineActionEnum {
  OFFER_REQUEST_CREATED = "offer_request_created",
  OFFER_REQUEST_STATUS_APPROVED = "offer_request_status_approved",
  OFFER_REQUEST_STATUS_DECLINED = "offer_request_status_declined",
  OFFER_CREATED = "offer_created",
  ORDER_PLACED = "order_placed",

  OFFER_OPTION_REQUEST_HOLD_APPROVED = "offer_option_request_hold_approved",
  OFFER_OPTION_REQUEST_HOLD_DECLINED = "offer_option_request_hold_declined",
  OFFER_OPTION_REQUEST_PACKAGING_PROVIDED = "offer_option_request_packaging_provided",
  OFFER_OPTION_REQUEST_PACKAGING_DECLINED = "offer_option_request_packaging_declined",
  OFFER_OPTION_REQUEST_PHOTO_PROVIDED = "offer_option_request_photo_provided",
  OFFER_OPTION_REQUEST_PHOTO_DECLINED = "offer_option_request_photo_declined",
  OFFER_OPTION_REQUEST_QUANTITY_PROVIDED = "offer_option_request_quantity_provided",
  OFFER_OPTION_REQUEST_QUANTITY_DECLINED = "offer_option_request_quantity_declined",
}
